import React from "react";
import classnames from "classnames";

/**
 * A self-contained spinner component using Tailwind CSS.
 *
 * @param {Object} props
 * @param {"sm" | "md" | "lg"} [props.size="md"] - Size of the spinner
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.label] - Accessibility label for screen readers
 */
export function Spinner({ size = "md", className, label = "Loading" }) {
  const sizeClasses = {
    sm: "h-2 w-2 border-2 m-1",
    md: "h-3 w-3 border-[3px] m-2",
    lg: "h-4 w-4 border-4 m-3",
  };

  return (
    <div
      role="status"
      aria-label={label}
      className={classnames(
        "animate-spin rounded-full border-solid border-t-transparent shrink-0",
        sizeClasses[size],
        className
      )}
      style={{
        borderColor: "var(--primary-cta-high-contrast)",
        borderTopColor: "transparent",
      }}
    >
      <span className="sr-only">{label}</span>
    </div>
  );
}

export default Spinner;
